const supplierQuotation = {
  status: '狀態',
  productCode: '商品編碼',
  productName: '商品名稱',
  productModel: '商品型號',
  productCount: '商品數量',
  mrd: '預計交貨時間',
  deadline: '最晚提交時間',
  mpq: '契约最小包裝',
  curMpq: '單次最小包裝',
  days: '契约供貨週期',
  curDays: '單次供貨週期',
  price: '契约價',
  curPrice: '單次報價',
  curTotalPrice: '單次總價',
  submitTimer: '提交倒數計時',
  operation: '操作',
  handlePrice: '報價',
  priceInfo: '報價資訊',
  rejected: '已拒絕',
  confirmQuotate: '確定報價麼？ ',
  confirmQuotateTip: '這將對該商品提交報價',
};

export default supplierQuotation;